import { get } from "lodash-es";
import { getTemplateResources } from "../../repositories/TemplatesRepositorie";

type Props = {
	TemplateId: number | null;
	setTemplateAttachmentsList: Function;
	setTemplateDrawingsList: Function;
	setTemplateLOTOList: Function;
	setTemplatePartsList: Function;
	setIsLoadingTemplateResourcesList: (isLoading: boolean) => void;
	setErrorTemplateResourcesList: (err: string) => void;
};

export const useSearchTemplateResources = ({
	TemplateId,
	setTemplateAttachmentsList,
	setTemplateDrawingsList,
	setTemplateLOTOList,
	setTemplatePartsList,
	setIsLoadingTemplateResourcesList,
	setErrorTemplateResourcesList,
}: Props) => {
	return async () => {
		setIsLoadingTemplateResourcesList(true);
		const res = await getTemplateResources(TemplateId as number);
		if (res.ok) {
			const TemplateDrawingsList = get(res, "data.tables[0].rows", []);
			setTemplateDrawingsList(TemplateDrawingsList);
			const TemplateLOTOList = get(res, "data.tables[1].rows", []);
			setTemplateLOTOList(TemplateLOTOList);
			const TemplatePartsList = get(res, "data.tables[2].rows", []);
			setTemplatePartsList(TemplatePartsList);
			const TemplateAttchmentsList = get(res, "data.tables[3].rows", []);
			setTemplateAttachmentsList(TemplateAttchmentsList);
			setIsLoadingTemplateResourcesList(false);
		} else {
			setIsLoadingTemplateResourcesList(false);
			setErrorTemplateResourcesList(res.message);
		}
	};
};
